// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"MainNav_mainNav__3bsCy","projectName":"MainNav_projectName__u9-lm","logo":"MainNav_logo__2JyG7"};